import React, { useState } from "react";
import "./NodeListInput.scss";

export const NodeListInput = ({ node, property, setSelected, nodeIndex, isTopNode }) => {
  const [search, setSearch] = useState("");
  return (
    <div className="list-input flex-column">
      <div className="list-input-head flex-row">
        <input
          type="text"
          placeholder="search"
          className="search"
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="list-input-list">
        {property.filterSearch(search).map((node, i) => (
          <div key={i} className="list-entry flex-row" onClick={() => setSelected(node, property)}>
            <div className="column">{node.getName()}</div>
            {/*<div className="delete button rounded" onClick={(e) => {*/}
            {/*    e.stopPropagation();*/}
            {/*    property.remove(node);*/}
            {/*}} title="löschen">✖</div>*/}
          </div>
        ))}
      </div>
      {property.canModifyList && (
        <div
          className="list-input-button button"
          title="neu erstellen"
          onClick={() => {
            const instance = property.createNode();
            property.add(instance);
            setSelected(instance, property);
          }}
        >
          neu erstellen
        </div>
      )}
    </div>
  );
};
